export const json_lang = `{
    "email": ["Will u meet ur dream partner soon? Is ur career off 2 a flyng start? 2 find out free, txt HORO followed by ur star sign, e. g. HORO ARIES"]
 }`

 export const curl_lang = `curl --location 'https://shieldscanserver13-vvf6wzt9.b4a.run/check_email_spam' \
 --header 'Content-Type: application/json' \
 --data '{
    "email": ["Will u meet ur dream partner soon? Is ur career off 2 a flyng start? 2 find out free, txt HORO followed by ur star sign, e. g. HORO ARIES"]
 }'`

 export const axios_lang = `const axios = require('axios');
 let data = JSON.stringify({
   "email": [
     "Will u meet ur dream partner soon? Is ur career off 2 a flyng start? 2 find out free, txt HORO followed by ur star sign, e. g. HORO ARIES"
   ]
 });
 
 let config = {
   method: 'post',
   maxBodyLength: Infinity,
   url: 'https://shieldscanserver13-vvf6wzt9.b4a.run/check_email_spam',
   headers: { 
     'Content-Type': 'application/json'
   },
   data : data
 };
 
 axios.request(config)
 .then((response) => {
   console.log(JSON.stringify(response.data));
 })
 .catch((error) => {
   console.log(error);
 });`